<form [formGroup]="dashboardTemplateForm">
       <script src="../../../../assets/userCss/dashbord/js/oprtnychart.js"></script>
       <div class="dashBordContent" id="template1" *ngIf="dashboardTemplateForm.value.templateCode == 'T1'">
              <div class="contentsection">
                     <div class="topColumns">
                            <app-profile-details></app-profile-details>
                            <div class="columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-1">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>

                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 100%; padding-top: 1rem;  ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock1">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>

                            <div class="donutChart show">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 90%; padding-top: 1rem; ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock2">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                     </div>

                     <div class="bottomColumns">
                            <app-dashboard-colored-column></app-dashboard-colored-column>
                            <div class="dashboardfooter">
                                   <div class="piechartcolumn">
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock3_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock3"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <div id="projectChart" class="chartshapes show"
                                                 style="height:20rem; width: 100%; padding-top: 1px; padding-bottom: 1px">
                                                 <svg>
                                                        <use
                                                               [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock3">
                                                        </use>
                                                 </svg>
                                          </div>
                                   </div>
                                   <app-bulletin></app-bulletin>
                            </div>

                     </div>
              </div>
              <div class="boardside">
                     <app-manage-presence></app-manage-presence>
                     <app-todays-event></app-todays-event>
                     <div class="absents">
                            <!-- <div class="coltitles"> -->
                            <!-- <h3>Absent Employees</h3> -->
                            <input type="text" formControlName="staticBlock1_heading" class="form-control inputText"
                                   maxlength="30" placeholder="Enter Heading">
                            <button class="edit-coloumn" id="showicons"
                                   (click)="updateChartType('staticBlock1','staticBlock1_heading')">Add
                                   Heading</button>
                            <!-- </div> -->
                            <app-absent-employee-list></app-absent-employee-list>
                     </div>
              </div>
       </div>
       <div class="dashBordContent" id="template2" *ngIf="dashboardTemplateForm.value.templateCode == 'T2'">
              <div class="contentsection">
                     <div class="crmgrid">
                            <div class="boxes columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock1','crm_chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="orangebars">
                                          <p>3 Leads in <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:80%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>3 Leads in <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:95%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Contract Made <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:80%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>3 Meeting Arranged <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:90%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Needs Demanded <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:75%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Proposal made <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:75%"></div>
                                          </div>
                                   </div>

                                   <!-- <div class="orangebars">
                                          <p>2 Negotiations Started <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:60%"></div>
                                          </div>
                                   </div> -->
                            </div>

                            <div class="boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock2','crm_chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="columnchart_values" style="height: 20rem; width: 100%;padding-bottom: 1px">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock2">
                                                 </use>
                                          </svg>
                                   </div>
                                   <!-- <div id="columnchart_values" class="chartshapes show"
                                          style="height:60%; width: 90%; padding-top: 1rem; ">
                                         
                                   </div> -->
                            </div>

                            <div class=" boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock3_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock3"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock3','crm_chartBlock3_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <table class="dashboard_table">
                                          <thead>
                                                 <tr>
                                                        <th scope="col"> &nbsp; </th>
                                                        <th scope="col">Finance</th>
                                                        <th scope="col">Retail</th>
                                                        <th scope="col">Insurance</th>
                                                 </tr>
                                          </thead>
                                          <tbody>
                                                 <tr>
                                                        <th scope="row">Deals Won</th>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                 </tr>
                                                 <tr>
                                                        <th scope="row">Deals Open</th>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                 </tr>
                                                 <tr>
                                                        <th scope="row">Deals Lost</th>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                 </tr>
                                          </tbody>
                                   </table>
                            </div>
                     </div>

                     <app-dashboard-crm-colored-column></app-dashboard-crm-colored-column>


                     <div class="crmgrid">
                            <div class="boxes columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock4_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock4"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock4','crm_chartBlock4_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="coloredbar">
                                          <div class="thik_progress red">
                                                 2000
                                          </div>
                                          <p>80%</p>
                                          <div class="thik_progress orange">
                                                 2000
                                          </div>

                                          <p>90%</p>
                                          <div class="thik_progress green">
                                                 3000
                                          </div>

                                          <p>50%</p>
                                          <div class="thik_progress blue">
                                                 2050
                                          </div>
                                   </div>
                                   <div class="colorbullet">
                                          <p><span class="red"></span>Leads Created</p>
                                          <p><span class="orange"></span>Leads Converted</p>
                                          <p><span class="green"></span>Leads Won</p>
                                          <p><span class="blue"></span>Leads Lost</p>
                                   </div>
                            </div>

                            <div class="boxes donutChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock5_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock5"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock5','crm_chartBlock5_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="TotalValueChart" style="width: 100%; height: 20rem;padding-bottom: 1px ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock5">
                                                 </use>
                                          </svg>
                                   </div>
                                   <!-- <div id="TotalValueChart" class="chartshapes show"
                                          style="height:60%; width: 90%; padding-top: 1rem; ">
                                          
                                   </div> -->
                            </div>

                            <div class="boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock6_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock6"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock6','crm_chartBlock6_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="budget_chart" style="width: 100%; height: 20rem;padding-bottom: 1px">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock6">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                     </div>

              </div>
              <div class="boardside dealslist">
                     <!-- <div class="coltitles"> -->
                     <!-- <h3>Top 5 Deals</h3> -->
                     <div class="form-row">
                            <div class="col">
                                   <!-- <label class="control-label">Chart Type</label> -->
                                   <input type="text" formControlName="crm_staticBlock1_heading"
                                          class="form-control inputText" maxlength="30" placeholder="Enter Heading">
                            </div>
                            <div class="col-2">
                                   <!-- <label class="control-label"
                                          style="color: transparent;">.</label> -->
                                   <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                          <button type="button" class="back09 widgetsave" title="Save"
                                                 (click)="updateChartType('crm_staticBlock1','crm_staticBlock1_heading')">
                                                 <svg class="icon">
                                                        <use href="assets/img/common-sprite.svg#saveIcon">
                                                        </use>
                                                 </svg>
                                          </button>
                                   </div>
                            </div>
                     </div>

                     <app-crm-top-five-deals></app-crm-top-five-deals>
              </div>
       </div>
       <div class="recruit-board" id="template3" *ngIf="dashboardTemplateForm.value.templateCode == 'T3'">
              <div class="boardcontent">
                     <div class="boardcolumns">
                            <div class="recruit-box">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                            <div class="recruit-box">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>

                                   <div class="donut"
                                          style="--first: .18; --second: .16; --third: .17; --fourth: .16; --fifth: .17; --sixth: .17;">
                                          <div class="donut__slice donut__slice__first">
                                                 <span> 1 </span>
                                          </div>
                                          <div class="donut__slice donut__slice__second">
                                                 <span> 2 </span>
                                          </div>
                                          <div class="donut__slice donut__slice__third">
                                                 <span> 3 </span>
                                          </div>
                                          <div class="donut__slice donut__slice__fourth">
                                                 <span> 4 </span>
                                          </div>
                                          <div class="donut__slice donut__slice__fifth">
                                                 <span> 5</span>
                                          </div>
                                          <div class="donut__slice donut__slice__sixth">
                                                 <span> 6</span>
                                          </div>
                                          <div class="donut__label">
                                                 <div class="donut__label__heading">
                                                        37
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="donut-colors">
                                          <p><span class="violetBg"></span> Application </p>
                                          <p><span class="newBlue"></span> Phone Screen </p>
                                          <p><span class="newRed"></span> MGR Interview </p>
                                          <p><span class="greenBg"></span> Onsite interview </p>
                                          <p><span class="orangeBg"></span> Offer </p>
                                          <p><span class="darkPink"></span> HIre </p>
                                   </div>

                            </div>
                            <div class="recruit-box ">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock3_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock3"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="gridbox">
                                          <div class="funnelouter">
                                                 <div class="funnelbar">
                                                        <p>Application</p>
                                                        <span style="flex: 0 0 100%;">100%</span>
                                                 </div>
                                                 <div class="funnelbar">
                                                        <p>Phone Screen</p>
                                                        <span style="flex: 0 0 70%;">70%</span>
                                                 </div>
                                                 <div class="funnelbar">
                                                        <p>MGR Interview</p>
                                                        <span style="flex: 0 0 55%;">55%</span>
                                                 </div>
                                                 <div class="funnelbar">
                                                        <p>Onsite interview</p>
                                                        <span style="flex: 0 0 45%;">45%</span>
                                                 </div>
                                                 <div class="funnelbar">
                                                        <p>Offer</p>
                                                        <span style="flex: 0 0 35%;">35%</span>
                                                 </div>
                                                 <div class="funnelbar">
                                                        <p>Hire</p>
                                                        <span style="flex: 0 0 29%;">29%</span>
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                            <div class="recruit-box">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock5_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock5"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock5','chartBlock5_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                            <div class="recruit-box largebox">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock6_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock6"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock6','chartBlock6_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                            </div>

                     </div>
              </div>
              <div class="boardSidebar">
                     <div class="recruit-box">
                            <div class="coltitles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock4_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock4"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock4','chartBlock4_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                     </div>
                     <div class="recruit-box">
                            <div class="coltitles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock7_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock7"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock7','chartBlock7_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>
                            </div>

                            <div class="declines">
                                   <div class="declines-titles">
                                          # of Apps
                                   </div>
                                   <div class="declines-titles">
                                          % of Apps
                                   </div>
                            </div>

                            <div class="declines">
                                   <div class="declines-names">
                                          <span>Technical</span>
                                          <span>8</span>
                                   </div>
                                   <div class="declines-bars">
                                          <div class="greenbar" style="width:60%;"></div>
                                          <div class="barpercent">60%</div>
                                   </div>
                            </div>

                            <div class="declines">
                                   <div class="declines-names">
                                          <span>Salary</span>
                                          <span>5</span>
                                   </div>
                                   <div class="declines-bars">
                                          <div class="greenbar" style="width: 40%;"></div>
                                          <div class="barpercent">40%</div>
                                   </div>
                            </div>


                            <div class="declines">
                                   <div class="declines-names">
                                          <span>Other</span>
                                          <span>4</span>
                                   </div>
                                   <div class="declines-bars">
                                          <div class="greenbar" style="width: 30%;"></div>
                                          <div class="barpercent">30%</div>
                                   </div>
                            </div>

                            <div class="declines">
                                   <div class="declines-names">
                                          <span>Cuture</span>
                                          <span>3</span>
                                   </div>
                                   <div class="declines-bars">
                                          <div class="greenbar" style="width: 22%;"></div>
                                          <div class="barpercent">22%</div>
                                   </div>
                            </div>

                            <div class="declines">
                                   <div class="declines-names">
                                          <span>Experiance</span>
                                          <span>2</span>
                                   </div>
                                   <div class="declines-bars">
                                          <div class="greenbar" style="width: 13%;"></div>
                                          <div class="barpercent">13%</div>
                                   </div>
                            </div>

                     </div>
              </div>
       </div>
       <div class="dashBordContent" id="template4" *ngIf="dashboardTemplateForm.value.templateCode == 'T4'">
              <div class="contentsection customer">
                     <div class="topColumns">
                            <app-profile-details></app-profile-details>
                            <div class="columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="cust_chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="cust_chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-1">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('cust_chartBlock1','cust_chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>

                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 100%; padding-top: 1rem;  ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock1">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>

                            <div class="donutChart show">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="cust_chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="cust_chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('cust_chartBlock2','cust_chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 90%; padding-top: 1rem; ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock2">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                     </div>

                     <div class="dashgrids">
                            <div class="progrids">
                                   <div class="coltitles">
                                          <!-- <h4>Timesheet Details
                                                               <Small>Project name</Small>
                                                        </h4>
                          
                                                        <select name="" id="">
                                                               <option selected>Select Project</option>
                                                               <option value="">Project name</option>
                                                        </select> -->
                                          <app-dashboard-timesheet-project-hours>
                                          </app-dashboard-timesheet-project-hours>
                                   </div>
                                   <!-- <table class="common_table">
                                                 <tr>
                                                  <th style="width: 6rem;">Emp No</th>
                                                  <th style="width: 55%;">Emp Name</th>
                                                  <th>Hours
                                                        <small>Dec</small>
                                                 </th>
                                                  <th>Hours 
                                                        <small>To-date</small> 
                                                 </th>
                                                  </tr>
                                                  <tr>
                                                         <td>303</td>
                                                         <td>Susan Mary Mathew</td>
                                                         <td>120 Hrs</td>
                                                         <td>40 Hrs</td>
                                                  </tr>
                                                  <tr>
                                                        <td>303</td>
                                                        <td>Susan Mary Mathew</td>
                                                        <td>120 Hrs</td>
                                                        <td>40 Hrs</td>
                                                 </tr>
                                                 <tr>
                                                        <td>303</td>
                                                        <td>Susan Mary Mathew</td>
                                                        <td>120 Hrs</td>
                                                        <td>40 Hrs</td>
                                                 </tr>
                                                 <tr>
                                                        <td>303</td>
                                                        <td>Susan Mary Mathew</td>
                                                        <td>120 Hrs</td>
                                                        <td>40 Hrs</td>
                                                 </tr>
                                                 <tr>
                                                        <td>303</td>
                                                        <td>Susan Mary Mathew</td>
                                                        <td>120 Hrs</td>
                                                        <td>40 Hrs</td>
                                                 </tr>
                                                  </table> -->
                            </div>

                            <div class="progrids">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="cust_chartBlock3_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="cust_chartBlock3"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-1">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('cust_chartBlock3','cust_chartBlock3_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="ProExpense" style="height: 25rem; width: 100%;"></div>
                            </div>

                     </div>

              </div>
              <div class="boardside customerside">
                     <div class="absents">
                            <!-- <div class="coltitles"> -->
                            <!-- <h3>Absent Employees</h3> -->
                            <input type="text" formControlName="cust_staticBlock1_heading"
                                   class="form-control inputText" maxlength="30" placeholder="Enter Heading">
                            <button class="edit-coloumn" id="showicons"
                                   (click)="updateChartType('cust_staticBlock1','cust_staticBlock1_heading')">Add
                                   Heading</button>
                            <!-- </div> -->
                            <app-absent-employee-list></app-absent-employee-list>
                     </div>
                     <div class="listodo">
                            <app-dashboard-to-do-list></app-dashboard-to-do-list>

                     </div>
              </div>
       </div>
       <div class="oppertunitydb" id="template5" *ngIf="dashboardTemplateForm.value.templateCode == 'T5'">

              <!-- <div class="oppertunitydb"> -->
              <h2>
                     Opportunity Dashboard
              </h2>

              <div class="oppertunitydbcontent">
                     <aside>
                            <div class="asidebox">
                                   <div class="newcolumtitlles">
                                          <h4>
                                                 Top 10 Open Opportunities
                                          </h4>

                                   </div>
                                   <table class="chartable2">


                                          <thead>
                                                 <tr>
                                                        <th>Opportunities Name</th>
                                                        <th>Status</th>
                                                 </tr>
                                          </thead>
                                          <tr>

                                                 <td>ACme</td>
                                                 <td class="greentxt">Open</td>
                                          </tr>
                                          <tr>
                                                 <td>IBM</td>
                                                 <td class="redtxt">Closed</td>
                                          </tr>
                                          <tr>
                                                 <td>Cloudamp LLC</td>
                                                 <td class="greentxt">Open</td>
                                          </tr>
                                          <tr>
                                                 <td>Microsoft Corporation</td>
                                                 <td class="greentxt">open</td>
                                          </tr>

                                          <tr>
                                                 <td>Acme</td>
                                                 <td class="redtxt">Closed</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td class="redtxt">Closed</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td class="greentxt">Open</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td class="redtxt">Closed</td>
                                          </tr>

                                   </table>
                            </div>
                            <div class="asidebox">
                                   <div class="newcolumtitlles">
                                          <h4>
                                                 Top 10 Won Opportunities
                                          </h4>

                                   </div>
                                   <table class="chartable2">
                                          <thead>
                                                 <tr>
                                                        <th>Opportunities Name</th>
                                                        <th>Amount</th>
                                                 </tr>
                                          </thead>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>

                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td>Acme</td>
                                                 <td>$250</td>
                                          </tr>

                                   </table>
                            </div>


                     </aside>
                     <article>


                            <div class="heighlitcolmns">

                                   <div class="colmn">
                                          <h4>OPEN OPPERTUNITY </h4>
                                          <div class="numbervalue">
                                                 <h3>158 </h3>

                                          </div>
                                   </div>
                                   <div class="colmn">
                                          <h4>EXPECTED REVENUE</h4><br>

                                          <div class="numbervalue">
                                                 <h3>$1.21M</h3>

                                          </div>
                                   </div>

                                   <div class="colmn">
                                          <h4>
                                                 REVENUE WON
                                          </h4>
                                          <div class="numbervalue">
                                                 <h3>$0.63M</h3>

                                          </div>
                                   </div>

                                   <div class="colmn">
                                          <h4>
                                                 Over Success Rate
                                          </h4>
                                          <div class="numbervalue">
                                                 <h3>$0.63M</h3>

                                          </div>
                                   </div>

                            </div>

                            <div class="whiteblocks">
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock1_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock1"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-1">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <!-- <div class="newcolumtitlles">
                                                    
                                                      <h4>
                                                             Revenue Closed This Quarter
                                                      </h4>  
                       
                                               </div> -->
                                          <div class="centerdgrid">
                                                 <div id="TotalValueChart" style="height: 23rem;"></div>
                                          </div>
                                   </div>

                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles">
                                                      <h4>
                                                             Deals Won Vs By Owner
                                                      </h4>
                       
                       
                                               </div> -->
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock2_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock2"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>

                                          <div id="barchart_material" style="height: 22rem;"></div>

                                   </div>

                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles">
                                                      <h4>
                                                             Opportunities By Campaign Types
                                                      </h4>
                                               </div> -->
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock3_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock3"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>
                                          <div id="donutchart" style="height: 20rem;"></div>
                                   </div>




                                   <!-- End -->
                            </div>

                            <div class="whiteblocks lessone">
                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles">
                                                      <h4>
                                                             Estimated Vs.Actual Revenue By month
                                                      </h4>
                       
                                               </div> -->
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock4_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock4"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock4','chartBlock4_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>

                                          <div id="bar_chart" style="height: 22rem;"></div>

                                   </div>

                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles">
                                                      <h4>
                                                             Task Completion
                                                      </h4>
                       
                                               </div> -->
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock5_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock5"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock5','chartBlock5_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>
                                          <div id="stackedbar_chart" style="height: 22rem;"></div>



                                   </div>






                                   <!-- End -->
                            </div>
                     </article>
              </div>
              <!-- </div> -->
       </div>

       <div class="empdashboard" id="template6" *ngIf="dashboardTemplateForm.value.templateCode == 'T6'">

              <article>
                     <h2>
                            Dashboard Overview
                     </h2>
                     <app-dashboard-colored-columnnew></app-dashboard-colored-columnnew>

                     <div class="whiteblocks single">
                            <div class="newcolumtitlles">
                                   <h4>
                                          Bulletin
                                   </h4>
                            </div>
                            <app-bulletinnew></app-bulletinnew>
                     </div>
                     <div class="whiteblocks">
                            <div class="columbox">
                                   <div class="newcolumtitlles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-1">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 100%; padding-top: 1rem;  ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock1">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                            <div class="columbox">
                                   <div class="newcolumtitlles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>

                                   </div>
                                   <div id="projectChart" class=""
                                          style="height:20rem; width: 90%; padding-top: 1rem; ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock2">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                     </div>
                     <div class="whiteblocks">
                            <div class="columbox">
                                   <div class="newcolumtitlles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="chartBlock3_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control" formControlName="chartBlock3"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="projectChart" class="chartshapes show"
                                          style="height:20rem; width: 100%; padding-top: 1px; padding-bottom: 1px">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock3">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                            <!-- <app-dashboard-to-do-listnew></app-dashboard-to-do-listnew> -->
                            <div class="columbox">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label"> Type</label>
                                                 <ng-select class="form-control" formControlName="emp_asideblock2"
                                                        [items]="empasidebox" placeholder="Select " bindLabel="name"
                                                        bindValue="name"></ng-select>
                                                 <!-- <select class="form-control" formControlName="emp_asideblock2">
                                                                                    <option  *ngFor="let item of empasidebox">{{item}}</option>                                               
                                                                        </select> -->

                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button class="back09 widgetsave" title="Save"
                                                               (click)="updateAsideboxType('emp_asideblock2','emp_asideblock2')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>

                                   </div>
                                   <app-profile-detailsnew *ngIf="empasidebox2=='Profile Details'">
                                   </app-profile-detailsnew>
                                   <div
                                          *ngIf="empasidebox2=='Absent Employee' || (empasidebox2==null || empasidebox2==''||empasidebox2=='columnChart')">
                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Absent Employees
                                                 </h4>
                                                 <div class="rightsideoptions">

                                                        <h5>
                                                               Today
                                                        </h5>
                                                 </div>
                                          </div>
                                          <!-- <app-absent-employee-listnew></app-absent-employee-listnew> -->
                                          <div style="max-height: 15rem; overflow-y: auto;cursor: pointer;">
                                                 <ul class="absentemps">
                                                        <li>
                                                               <figure>
                                                                      <img src="../../../../assets/img/user.jpg" alt="">
                                                                      <figcaption>
                                                                             <p>
                                                                                    <strong>Joe</strong>
                                                                                    Software engineer
                                                                             </p>
                                                                      </figcaption>
                                                               </figure>
                                                               <span>
                                                                      India
                                                               </span>
                                                        </li>
                                                        <li>
                                                               <figure>
                                                                      <img src="../../../../assets/img/user.jpg" alt="">
                                                                      <figcaption>
                                                                             <p>
                                                                                    <strong>Joe</strong>
                                                                                    Software engineer
                                                                             </p>
                                                                      </figcaption>
                                                               </figure>
                                                               <span>
                                                                      Usa
                                                               </span>
                                                        </li>
                                                        <li>
                                                               <figure>
                                                                      <img src="../../../../assets/img/user.jpg" alt="">
                                                                      <figcaption>
                                                                             <p>
                                                                                    <strong>Joe</strong>
                                                                                    Software engineer
                                                                             </p>
                                                                      </figcaption>
                                                               </figure>
                                                               <span>
                                                                      India
                                                               </span>
                                                        </li>
                                                        <li>
                                                               <figure>
                                                                      <img src="../../../../assets/img/user.jpg" alt="">
                                                                      <figcaption>
                                                                             <p>
                                                                                    <strong>Joe</strong>
                                                                                    Software engineer
                                                                             </p>
                                                                      </figcaption>
                                                               </figure>
                                                               <span>
                                                                      Usa
                                                               </span>
                                                        </li>
                                                 </ul>
                                          </div>
                                   </div>

                            </div>
                     </div>
              </article>
              <aside style="grid-template-rows:6rem auto;">

                     <!-- <div class="asidebox userdetails">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label"> Type</label>
                                                 <ng-select class="form-control" formControlName="emp_asideblock1"
                                                        [items]="empasidebox" placeholder="Select " bindLabel="name"
                                                        bindValue="name"></ng-select>

                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button class="back09 widgetsave" title="Save"
                                                               (click)="updateAsideboxType('emp_asideblock1','emp_asideblock1')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>

                                                 </div>
                                          </div>

                                   </div>
                                   <app-profile-detailsnew
                                          *ngIf="empasidebox1=='Profile Details' || (empasidebox1==null||empasidebox1==''||empasidebox1=='columnChart')">
                                   </app-profile-detailsnew>
                                   <div *ngIf="empasidebox1=='Absent Employee'">
                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Absent Employees
                                                 </h4>
                                                 <div class="rightsideoptions">

                                                        <h5>
                                                               Today
                                                        </h5>
                                                 </div>
                                          </div>
                                         

                                          <ul class="absentemps">
                                                 <li>
                                                        <figure>
                                                               <img src="../../../../assets/img/user.jpg" alt="">
                                                               <figcaption>
                                                                      <p>
                                                                             <strong>Joe</strong>
                                                                             Software engineer
                                                                      </p>
                                                               </figcaption>
                                                        </figure>
                                                        <span>
                                                               India
                                                        </span>
                                                 </li>
                                                 <li>
                                                        <figure>
                                                               <img src="../../../../assets/img/user.jpg" alt="">
                                                               <figcaption>
                                                                      <p>
                                                                             <strong>Joe</strong>
                                                                             Software engineer
                                                                      </p>
                                                               </figcaption>
                                                        </figure>
                                                        <span>
                                                               Usa
                                                        </span>
                                                 </li>
                                                 <li>
                                                        <figure>
                                                               <img src="../../../../assets/img/user.jpg" alt="">
                                                               <figcaption>
                                                                      <p>
                                                                             <strong>Joe</strong>
                                                                             Software engineer
                                                                      </p>
                                                               </figcaption>
                                                        </figure>
                                                        <span>
                                                               India
                                                        </span>
                                                 </li>
                                                 <li>
                                                        <figure>
                                                               <img src="../../../../assets/img/user.jpg" alt="">
                                                               <figcaption>
                                                                      <p>
                                                                             <strong>Joe</strong>
                                                                             Software engineer
                                                                      </p>
                                                               </figcaption>
                                                        </figure>
                                                        <span>
                                                               Usa
                                                        </span>
                                                 </li>
                                          </ul>
                                   </div>
                            </div> -->
                     <div class="asidebox">
                            <app-event-mailbox-buttons></app-event-mailbox-buttons>
                     </div>
                     <div class="asidebox">
                            <div class="newcolumtitlles">
                                   <h4>
                                          Schedule Meeting
                                   </h4>
                                   <div class="rightsideoptions">
                                          <button>
                                                 <svg>
                                                        <use href="./assets/img/sprite.svg#zoom"></use>
                                                 </svg>
                                          </button>
                                   </div>
                            </div>
                            <div style="max-height: 27rem; overflow-y:auto">
                                   <ul class="newmeetings">
                                          <li>

                                                 <p>
                                                        <strong>Schedule By: XYZ</strong>
                                                        Test meeting- 12:30 PM
                                                 </p>

                                                 <a href="" target="_blank">
                                                        Click here
                                                 </a>
                                          </li>
                                   </ul>
                            </div>
                     </div>

                     <div class="asidebox">
                            <div class="newcolumtitlles">
                                   <h4>
                                          ToDo list
                                   </h4>
                                   <div class="rightsideoptions">

                                          <button>
                                                 View All
                                          </button>
                                   </div>
                            </div>
                            <div style="max-height: 27rem; overflow-y:auto">
                                   <ul class="newtodolist">
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                   </ul>
                            </div>
                     </div>
              </aside>

       </div>
       <div class="content-wraper" id="template7" *ngIf="dashboardTemplateForm.value.templateCode == 'T7'">
              <div class="crmdashboard">
                     <article>
                            <h2>
                                   CRM Dashboard
                            </h2>
                            <div class="heighlitcolmns">
                                   <div class="colmn">
                                          <h4>
                                                 Deals Started
                                          </h4>
                                          <div class="numbervalue">
                                                 <h3>0 <span>6</span></h3>

                                          </div>
                                   </div>
                                   <div class="colmn">
                                          <h4>
                                                 Lost Deals
                                          </h4>
                                          <div class="numbervalue">
                                                 <h3>2<span>0</span></h3>

                                          </div>
                                   </div>
                                   <div class="colmn">
                                          <h4>
                                                 Won Deals
                                          </h4>
                                          <div class="numbervalue">
                                                 <h3>1<span>1</span></h3>

                                          </div>
                                   </div>
                            </div>

                            <div class="whiteblocks">
                                   <div class="columbox">
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text"
                                                                      formControlName="crm_chartBlock1_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="crm_chartBlock1"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('crm_chartBlock1','crm_chartBlock1_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <div class="orangebars">
                                                 <p>73 Leads in <span>73</span></p>
                                                 <div class="thinprogress">
                                                        <div class="bars" style="width:73%"></div>
                                                 </div>
                                          </div>

                                          <div class="orangebars">
                                                 <p>30 Leads in <span>30</span></p>
                                                 <div class="thinprogress">
                                                        <div class="bars blue" style="width:30%"></div>
                                                 </div>
                                          </div>

                                          <div class="orangebars">
                                                 <p>20 Contract Made <span>20</span></p>
                                                 <div class="thinprogress">
                                                        <div class="bars pink" style="width:20%"></div>
                                                 </div>
                                          </div>

                                   </div>
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <div class="coltitles">
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Title</label>
                                                                      <input type="text"
                                                                             formControlName="crm_chartBlock2_heading"
                                                                             class="form-control inputText"
                                                                             maxlength="30" placeholder="Enter Heading">
                                                               </div>
                                                        </div>
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Type</label>
                                                                      <ng-select class="form-control"
                                                                             formControlName="crm_chartBlock2"
                                                                             [items]="chartTypeOptions"
                                                                             placeholder="Select Chart" bindLabel="name"
                                                                             bindValue="id"></ng-select>
                                                               </div>
                                                               <div class="col-2">
                                                                      <label class="control-label"
                                                                             style="color: transparent;">.</label>
                                                                      <div class="spriteBtns btn-margin-top"
                                                                             style="padding-top: 2px;">
                                                                             <button type="button"
                                                                                    class="back09 widgetsave"
                                                                                    title="Save"
                                                                                    (click)="updateChartType('crm_chartBlock2','crm_chartBlock2_heading')">
                                                                                    <svg class="icon">
                                                                                           <use
                                                                                                  href="assets/img/common-sprite.svg#saveIcon">
                                                                                           </use>
                                                                                    </svg>
                                                                             </button>
                                                                      </div>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>
                                          <div id="sourcestatus" style="height: 23rem;">
                                                 <!-- <app-chart-controls [chartForm]="chartForm2"></app-chart-controls> -->
                                          </div>
                                   </div>
                            </div>
                            <div class="whiteblocks">

                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles"> -->
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text"
                                                                      formControlName="crm_chartBlock4_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="crm_chartBlock4"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('crm_chartBlock4','crm_chartBlock4_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>

                                          </div>
                                          <div class="coloredbar">
                                                 <div class="thik_progress red">

                                                 </div>
                                                 <p>80%</p>
                                                 <div class="thik_progress orange">

                                                 </div>

                                                 <p>90%</p>
                                                 <div class="thik_progress green">

                                                 </div>

                                                 <p>50%</p>
                                                 <div class="thik_progress blue">

                                                 </div>
                                          </div>
                                          <div class="colorbullet">
                                                 <p><span class="red"></span>Created</p>
                                                 <p><span class="orange"></span>Converted</p>
                                                 <p><span class="green"></span>Won</p>
                                                 <p><span class="blue"></span>Lost</p>
                                          </div>
                                   </div>
                                   <div class="columbox">
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text"
                                                                      formControlName="crm_chartBlock6_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="crm_chartBlock6"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('crm_chartBlock6','crm_chartBlock6_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <div id="budget_chart" style="width: 100%; height: 20rem;padding-bottom: 1px">
                                                 <svg>
                                                        <use
                                                               [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock6">
                                                        </use>
                                                 </svg>
                                          </div>
                                          <div id="actulagoal" style="height: 23rem; width: 50rem;">

                                          </div>
                                   </div>
                            </div>
                            <div class="whiteblocks">

                                   <div class="columbox">
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text"
                                                                      formControlName="crm_chartBlock3_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="crm_chartBlock3"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('crm_chartBlock3','crm_chartBlock3_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <table class="chartable">
                                                 <thead>
                                                        <tr>
                                                               <th scope="col"></th>
                                                               <th scope="col">Deals won</th>
                                                               <th scope="col">Deals open</th>
                                                               <th scope="col">Deals lost</th>
                                                        </tr>
                                                 </thead>

                                                 <tbody>
                                                        <tr>
                                                               <th scope="row" class="pink">Hospitality</th>
                                                               <td>0</td>
                                                               <td>1</td>
                                                               <td>2</td>
                                                        </tr>
                                                        <tr>
                                                               <th scope="row" class="blue">Financial</th>
                                                               <td>0</td>
                                                               <td>1</td>
                                                               <td>2</td>
                                                        </tr>
                                                        <tr>
                                                               <th scope="row" class="green">IT</th>
                                                               <td>0</td>
                                                               <td>1</td>
                                                               <td>2</td>
                                                        </tr>


                                                 </tbody>
                                          </table>
                                   </div>
                                   <div class="columbox">
                                          <!-- <div class="newcolumtitlles"> -->
                                          <div class="coltitles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text"
                                                                      formControlName="crm_chartBlock5_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="crm_chartBlock5"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('crm_chartBlock5','crm_chartBlock5_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>


                                          <!-- </div> -->
                                          <div id="curve_chart" style="height: 23rem;">
                                          </div>
                                   </div>
                            </div>
                     </article>
                     <aside>

                            <div class="asidebox">
                                   <div class="asidetitle">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <!-- <label class="control-label">Chart Type</label> -->
                                                        <input type="text" formControlName="crm_staticBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                                 <div class="col-2">
                                                        <!-- <label class="control-label"
                                                        style="color: transparent;">.</label> -->
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_staticBlock1','crm_staticBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>

                                   </div>
                                   <ul class="absentemps">
                                          <li>
                                                 <span>
                                                        1
                                                 </span>
                                                 <div>
                                                        <h5>
                                                               Abc Solutions $1700
                                                        </h5>
                                                        <p>
                                                               <strong>
                                                                      Sales rep:
                                                               </strong>
                                                               Wilson fisk
                                                        </p>
                                                        <p>
                                                               <strong>
                                                                      Sales cycle length
                                                               </strong>
                                                               69 days
                                                        </p>

                                                 </div>
                                          </li>
                                          <li>
                                                 <span>
                                                        2
                                                 </span>
                                                 <div>
                                                        <h5>
                                                               Abc Solutions $1700
                                                        </h5>
                                                        <p>
                                                               <strong>
                                                                      Sales rep:
                                                               </strong>
                                                               Wilson fisk
                                                        </p>
                                                        <p>
                                                               <strong>
                                                                      Sales cycle length
                                                               </strong>
                                                               69 days
                                                        </p>

                                                 </div>
                                          </li>
                                          <li>
                                                 <span>
                                                        3
                                                 </span>
                                                 <div>
                                                        <h5>
                                                               Abc Solutions $1700
                                                        </h5>
                                                        <p>
                                                               <strong>
                                                                      Sales rep:
                                                               </strong>
                                                               Wilson fisk
                                                        </p>
                                                        <p>
                                                               <strong>
                                                                      Sales cycle length
                                                               </strong>
                                                               69 days
                                                        </p>

                                                 </div>
                                          </li>
                                          <li>

                                   </ul>
                            </div>
                     </aside>
              </div>
       </div>

       <div class="recrdashboard" id="template8" *ngIf="dashboardTemplateForm.value.templateCode == 'T8'">

              <h2>
                     Recruitment Dashboard
              </h2>
              <div class="heighlitcolmns">
                     <div class="colmn">
                            <h4>
                                   Open Requisitions
                            </h4>
                            <div class="numbervalue">
                                   <h3>0 </h3>

                            </div>
                     </div>
                     <div class="colmn">
                            <h4>
                                   Offerd
                            </h4>
                            <div class="numbervalue">
                                   <h3>2</h3>

                            </div>
                     </div>
                     <div class="colmn">
                            <h4>
                                   Hired
                            </h4>
                            <div class="numbervalue">
                                   <h3>1</h3>

                            </div>
                     </div>
              </div>

              <div class="whiteblocks plusone">
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock1_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock1"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>

                            <div id="columnchart_values" style="height: 23rem;">
                                   <!-- <app-chart-controls [chartForm]="chartForm1"></app-chart-controls> -->
                            </div>

                     </div>
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock2_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock2"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>
                            <div id="newpiechart" style="height: 23rem;">
                                   <!-- <app-chart-controls [chartForm]="chartForm3"></app-chart-controls> -->
                            </div>
                     </div>
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock3_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock3"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>
                            <div class="funnelwithvalue">
                                   <ul class="newfunnelvalue">
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                          <li>
                                                 Requisitions - 10%
                                          </li>
                                   </ul>
                                   <ul class="newfunnel">
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                          <li>
                                                 <span>&nbsp;</span>
                                          </li>
                                   </ul>
                            </div>
                     </div>
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock4_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock4"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock4','chartBlock4_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>
                            <div id="series_chart_div" style="height: 23rem;">
                                   <!-- <app-chart-controls [chartForm]="chartForm4"></app-chart-controls> -->
                            </div>
                     </div>
              </div>
              <div class="whiteblocks">
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock6_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock6"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock6','chartBlock6_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>
                            <div id="curve_chart" style="height: 23rem;">
                                   <!-- <app-chart-controls [chartForm]="chartForm6"></app-chart-controls> -->
                            </div>
                     </div>
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock5_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock5"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock5','chartBlock5_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>
                            <!-- <app-chart-controls [chartForm]="chartForm5"></app-chart-controls> -->
                            <div class="circlebars">

                                   <div role="progressgreenbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"
                                          style="--value:55"></div>
                                   <div role="progressbluebar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"
                                          style="--value:25"></div>
                                   <div role="progressyellowbar" aria-valuenow="15" aria-valuemin="0"
                                          aria-valuemax="100" style="--value:15"></div>
                            </div>
                            <div class="circlebullet">
                                   <p><span class="green"></span>Reffrel</p>
                                   <p><span class="blue"></span>Talent Management</p>
                                   <p><span class="yellow"></span>others</p>
                            </div>
                     </div>
                     <div class="columbox">
                            <div class="newcolumtitlles">
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Title</label>
                                                 <input type="text" formControlName="chartBlock7_heading"
                                                        class="form-control inputText" maxlength="30"
                                                        placeholder="Enter Heading">
                                          </div>
                                   </div>
                                   <div class="form-row">
                                          <div class="col">
                                                 <label class="control-label">Chart Type</label>
                                                 <ng-select class="form-control" formControlName="chartBlock7"
                                                        [items]="chartTypeOptions" placeholder="Select Chart"
                                                        bindLabel="name" bindValue="id"></ng-select>
                                          </div>
                                          <div class="col-2">
                                                 <label class="control-label" style="color: transparent;">.</label>
                                                 <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                                        <button type="button" class="back09 widgetsave" title="Save"
                                                               (click)="updateChartType('chartBlock7','chartBlock7_heading')">
                                                               <svg class="icon">
                                                                      <use
                                                                             href="assets/img/common-sprite.svg#saveIcon">
                                                                      </use>
                                                               </svg>
                                                        </button>
                                                 </div>
                                          </div>
                                   </div>

                            </div>

                            <div class="orangebars">
                                   <p>30 Leads in <span>30</span></p>
                                   <div class="thinprogress">
                                          <div class="bars blue" style="width:30%"></div>
                                   </div>
                            </div>

                            <div class="orangebars">
                                   <p>20 Contract Made <span>20</span></p>
                                   <div class="thinprogress">
                                          <div class="bars pink" style="width:20%"></div>
                                   </div>
                            </div>

                            <div class="orangebars">
                                   <p>0 Meeting Arranged <span>0</span></p>
                                   <div class="thinprogress">
                                          <div class="bars green" style="width:25%"></div>
                                   </div>
                            </div>

                            <div class="orangebars">
                                   <p>5 Needs Demanded <span>5</span></p>
                                   <div class="thinprogress">
                                          <div class="bars violet" style="width:5%"></div>
                                   </div>
                            </div>

                     </div>
              </div>


       </div>

       <div class="content-wraper" *ngIf="dashboardTemplateForm.value.templateCode =='T10'">

              <div class="empdashboardgstiusa">
                     <article>
                            <h2>
                                   Dashboard Overview
                            </h2>
                            <div class="whiteblocks withbday">
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Bulletin
                                                 </h4>
                                          </div>
                                          <div style="overflow-y: auto; display: grid; height: 7.3rem; cursor:pointer;">
                                                 <app-bulletinnew></app-bulletinnew>
                                          </div>
                                   </div>
                                   <div class="columbox">

                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Birthday
                                                 </h4>
                                          </div>
                                          <div style="overflow-y: auto; display: grid; height: 7.3rem; cursor:pointer;">
                                                 <app-todays-event></app-todays-event>
                                          </div>
                                   </div>
                            </div>
                            <div class="whiteblocks">
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock1_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock1"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-1">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <div id="projectChart" class=""
                                                 style="height:20rem; width: 100%; padding-top: 1rem;  ">
                                                 <svg>
                                                        <use
                                                               [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock1">
                                                        </use>
                                                 </svg>
                                          </div>
                                   </div>
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Timesheet Status
                                                 </h4>
                                                 <div class="rightsideoptions">
                                                        <select name="" id="">
                                                               <option value='{{itm.id}}'
                                                                      *ngFor="let itm of (Weekoptiontype)"
                                                                      [selected]="(itm.id == '0')">{{itm.name}}
                                                               </option>
                                                        </select>
                                                 </div>
                                          </div>
                                          <div id="dealsourceChart">
                                                 <!-- <app-user-timesheet-status-dashboard  ></app-user-timesheet-status-dashboard> -->
                                          </div>
                                   </div>
                            </div>
                            <div class="whiteblocks">
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Title</label>
                                                               <input type="text" formControlName="chartBlock3_heading"
                                                                      class="form-control inputText" maxlength="30"
                                                                      placeholder="Enter Heading">
                                                        </div>
                                                 </div>
                                                 <div class="form-row">
                                                        <div class="col">
                                                               <label class="control-label">Chart Type</label>
                                                               <ng-select class="form-control"
                                                                      formControlName="chartBlock3"
                                                                      [items]="chartTypeOptions"
                                                                      placeholder="Select Chart" bindLabel="name"
                                                                      bindValue="id"></ng-select>
                                                        </div>
                                                        <div class="col-2">
                                                               <label class="control-label"
                                                                      style="color: transparent;">.</label>
                                                               <div class="spriteBtns btn-margin-top"
                                                                      style="padding-top: 2px;">
                                                                      <button type="button" class="back09 widgetsave"
                                                                             title="Save"
                                                                             (click)="updateChartType('chartBlock3','chartBlock3_heading')">
                                                                             <svg class="icon">
                                                                                    <use
                                                                                           href="assets/img/common-sprite.svg#saveIcon">
                                                                                    </use>
                                                                             </svg>
                                                                      </button>
                                                               </div>
                                                        </div>
                                                 </div>
                                          </div>
                                          <div id="projectChart" class="chartshapes show"
                                                 style="height:20rem; width: 100%; padding-top: 1px; padding-bottom: 1px">
                                                 <svg>
                                                        <use
                                                               [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.chartBlock3">
                                                        </use>
                                                 </svg>
                                          </div>
                                   </div>
                                   <div class="columbox">
                                          <div class="newcolumtitlles">
                                                 <h4>
                                                        Time Off Status
                                                 </h4>
                                                 <div class="rightsideoptions">
                                                        <select name="" id="">
                                                               <option value='{{itm.id}}'
                                                                      *ngFor="let itm of (Weekoptiontype)"
                                                                      [selected]="(itm.id == '0')">{{itm.name}}
                                                               </option>
                                                        </select>
                                                 </div>
                                          </div>
                                          <div id="employees">
                                                 <!-- <app-user-timeout-status-dashboard ></app-user-timeout-status-dashboard> -->
                                          </div>
                                   </div>
                            </div>
                     </article>
                     <aside style="grid-template-rows:6rem auto;">

                            <div class="asidebox">
                                   <app-event-mailbox-buttons></app-event-mailbox-buttons>
                            </div>
                            <div class="asidebox">
                                   <div class="newcolumtitlles">
                                          <h4>
                                                 Schedule Meeting
                                          </h4>
                                          <div class="rightsideoptions">
                                                 <button>
                                                        <svg>
                                                               <use href="./assets/img/sprite.svg#zoom"></use>
                                                        </svg>
                                                 </button>
                                          </div>
                                   </div>
                                   <div style="max-height: 27rem; overflow-y:auto">
                                          <ul class="newmeetings">
                                                 <li>

                                                        <p>
                                                               <strong>Schedule By: XYZ</strong>
                                                               Test meeting- 12:30 PM
                                                        </p>

                                                        <a href="" target="_blank">
                                                               Click here
                                                        </a>
                                                 </li>
                                          </ul>
                                   </div>
                            </div>

                            <div class="asidebox">
                                   <div class="newcolumtitlles">
                                          <h4>
                                                 ToDo list
                                          </h4>
                                          <div class="rightsideoptions">

                                                 <button>
                                                        View All
                                                 </button>
                                          </div>
                                   </div>
                                   <div style="max-height: 27rem; overflow-y:auto">
                                          <ul class="newtodolist">
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="green">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="green">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="green">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="green">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="red">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="red">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                                 <li>
                                                        Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                        <span class="red">
                                                               10-05-2022
                                                        </span>
                                                 </li>
                                          </ul>
                                   </div>
                            </div>
                     </aside>

              </div>
       </div>
       <div class="empdashboard" id="template6" *ngIf="dashboardTemplateForm.value.templateCode == 'T11'">

              <article>
                     <h2>
                            Dashboard Overview contacts
                     </h2>
                     <app-dashboard-colored-columnnew [customtile]="Contact"></app-dashboard-colored-columnnew>

                     <div class="whiteblocks single">
                            <div class="newcolumtitlles">
                                   <h4>
                                          Bulletin
                                   </h4>
                            </div>
                            <div style="overflow-y: auto; display: grid; height: 12rem; cursor:pointer;">
                                   <app-bulletinnew></app-bulletinnew>
                            </div>
                     </div>
                     <div class="whiteblocks single">
                            <!-- <div class="columbox"></div> -->
                     </div>
              </article>
              <aside style="grid-template-rows:6rem auto;">

                     <div class="asidebox">
                            <app-event-mailbox-buttons></app-event-mailbox-buttons>
                     </div>
                     <div class="asidebox">
                            <div class="newcolumtitlles">
                                   <h4>
                                          Schedule Meeting
                                   </h4>
                                   <div class="rightsideoptions">
                                          <button>
                                                 <svg>
                                                        <use href="./assets/img/sprite.svg#zoom"></use>
                                                 </svg>
                                          </button>
                                   </div>
                            </div>
                            <div style="max-height: 27rem; overflow-y:auto">
                                   <ul class="newmeetings">
                                          <li>

                                                 <p>
                                                        <strong>Schedule By: XYZ</strong>
                                                        Test meeting- 12:30 PM
                                                 </p>

                                                 <a href="" target="_blank">
                                                        Click here
                                                 </a>
                                          </li>
                                   </ul>
                            </div>
                     </div>

                     <div class="asidebox">
                            <div class="newcolumtitlles">
                                   <h4>
                                          ToDo list
                                   </h4>
                                   <div class="rightsideoptions">

                                          <button>
                                                 View All
                                          </button>
                                   </div>
                            </div>
                            <div style="max-height: 27rem; overflow-y:auto">
                                   <ul class="newtodolist">
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="green">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                          <li>
                                                 Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                 <span class="red">
                                                        10-05-2022
                                                 </span>
                                          </li>
                                   </ul>
                            </div>
                     </div>
              </aside>

       </div>
       <div class="empdashboard" id="template6" *ngIf="dashboardTemplateForm.value.templateCode == 'T12'">
              <div class="newjtsdb">
                     <div class="slidercolm">
                            <article>
                                   <h3>
                                          Bulletin
                                   </h3>
                                   <app-bulletin-release></app-bulletin-release>

                            </article>
                            <picture>
                                   <img src="./assets/img/main_right_bg.png" alt="">
                            </picture>
                     </div>
                     <div class="bottomdivisions">
                            <div class="leftcolmns">
                                   <div class="leftcolmns-top">
                                          <div class="clmnbox">
                                                 <div class="title">
                                                        <h4>
                                                               Newly added contacts
                                                        </h4>
                                                        <button class="btndark" title="Click to view all contacts">
                                                               View all
                                                        </button>
                                                 </div>
                                                 <div class="datagridone">
                                                        <article>
                                                               <ul class="datagridone_contents bold">
                                                                      <li>
                                                                             Name
                                                                      </li>
                                                                      <li>
                                                                             Title
                                                                      </li>
                                                                      <li>
                                                                             Company Name
                                                                      </li>
                                                                      <li>
                                                                             Type
                                                                      </li>
                                                                      <li>
                                                                             Quick links
                                                                      </li>
                                                               </ul>
                                                               <ul class="datagridone_contents">
                                                                      <li>
                                                                             <img src="./assets/img/avatar.png" alt="">
                                                                             <p>
                                                                                    name
                                                                             </p>
                                                                      </li>
                                                                      <li>
                                                                             job_title
                                                                      </li>
                                                                      <li>
                                                                             company
                                                                      </li>
                                                                      <li>
                                                                             type
                                                                      </li>
                                                                      <li>

                                                                             <a href="">
                                                                                    <button title="Click to call"
                                                                                           class="newiconlink green">
                                                                                           <svg>
                                                                                                  <use
                                                                                                         href="./assets/img/sprite.svg#call">
                                                                                                  </use>
                                                                                           </svg>
                                                                                    </button>
                                                                             </a>
                                                                             <a href="">
                                                                                    <button title="Click to mail"
                                                                                           class="newiconlink blue">
                                                                                           <svg>
                                                                                                  <use
                                                                                                         href="./assets/img/sprite.svg#mail">
                                                                                                  </use>
                                                                                           </svg>
                                                                                    </button>
                                                                             </a>
                                                                      </li>
                                                               </ul>

                                                        </article>
                                                        <!-- <picture>
                                             <img src="./assets/img/Contacts.png" alt="">
                                         </picture> -->
                                                 </div>
                                          </div>
                                          <div class="clmnbox grid">
                                                 <app-dashboard-event-buttons></app-dashboard-event-buttons>

                                          </div>
                                   </div>
                                   <div class="leftcolmns-bottom">
                                          <div class="clmnbox">
                                                 <app-dashboard-birthday-anniversary></app-dashboard-birthday-anniversary>

                                          </div>
                                          <div class="clmnbox">
                                                 <app-dashboard-todo-list-alt [data]="'CONTACTS'"></app-dashboard-todo-list-alt>

                                          </div>
                                   </div>
                            </div>
                            <div class="clmnbox">
                                   <div class="title">
                                          <h4>
                                                 Scheduled meeting
                                          </h4>
                                          <button class="newiconlink red" title="Click to Schedule Meeting">
                                                 <svg>
                                                        <use href="./assets/img/sprite.svg#zoom"></use>
                                                 </svg>
                                          </button>
                                   </div>
                                   <div class="colmcontent">
                                          <div class="newtabtns">
                                                 <button class="active" title="Click to Zoom meeting">
                                                        Zoom meeting
                                                 </button>
                                                 <button class="" title="Click to Team meeting">
                                                        Team meeting
                                                 </button>
                                          </div>
                                          <div class="newtabcontents">
                                                 <h4>
                                                        Select meeting
                                                 </h4>
                                                 <input class="comninput" type="text">
                                                 <ul class="newmeetinglist">
                                                        <li>
                                                               <span>Hostby Topic - StartTime</span>
                                                               <a title="Click to join meeting" href="" target="_blank">
                                                                      Click here
                                                               </a>
                                                               <!-- <div class="radioGroup">
                                             <input type="checkbox" (change)="clickonmetting(item.JoinUrl)"  id="check_1" class="toggleBtn" value="1" checked>
                                             <label for="check_1"></label>
                                           </div> -->
                                                        </li>
                                                        <!-- <li>
                                             <span>Meeting OG</span> 
                                             <div class="radioGroup">
                                                 
                                               </div>
                                          </li> -->

                                                 </ul>
                                          </div>
                                          <picture>
                                                 <img src="./assets/img/Schedule-Meeting.png" alt="">
                                          </picture>
                                   </div>
                            </div>
                     </div>
              </div>
       </div>
       <div class="empdashboard" id="template6" *ngIf="dashboardTemplateForm.value.templateCode == 'T13'">
              <div class="newjtsdbhrm">
                     <div class="slidercolm">
                            <article>
                                   <h3>
                                          HR Management Dashboard
                                   </h3>
                                   To us, an HR Manager is the go-to person for all employee-related issue. This means
                                   that your HR Manager
                                   duties will involve
                                   managing activities such as job design,recruitment,employee relations, performance
                                   management, training
                                   & development
                                   and talent management.

                            </article>
                            <picture>
                                   <img src="./assets/img/main_right_bg.png" alt="">
                            </picture>
                     </div>
                     <div class="bottomdivisions">
                            <div class="leftcolmns">
                                   <div class="leftcolmns-top">
                                          <div class="clmnbox">
                                                 <div class="title">
                                                        <h4>
                                                               Project Hours Tracked
                                                        </h4>
                                                        <!-- <div class="rightsideoptions">
                                             <select *ngIf="projectListData.length>0" (change)="onPrjEmplist_change($event)">
                                                 <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                                     [selected]="(itm.gstibo_project_id == defaultEmpProjectId  ? true : false)">
                                                     {{itm.gstibo_project_name}}
                                                 </option>
                                             </select>
                                         </div> -->
                                                 </div>
                                                 <div id="dealsourceChart">
                                                        <!-- <app-chart-controls [chartForm]="chartForm1"></app-chart-controls> -->
                                                 </div>
                                                 <!-- <div class="datagridone">
                                         
                                         <app-user-timesheet-status-dashboard
                                             [data]="timesheetweek"></app-user-timesheet-status-dashboard>
                                     </div> -->
                                          </div>
                                          <div class="clmnbox ">
                                                 <app-dashboard-absent-employee>
                                                 </app-dashboard-absent-employee>
                                          </div>
                                   </div>
                                   <div class="leftcolmns-bottom">
                                          <div class="clmnbox">
                                                 <div class="title">
                                                        <h4>
                                                               Time Off details <small>- Past 6 months</small>
                                                        </h4>
                                                 </div>
                                                 <div id="columnchart_material">
                                                        <!-- <app-chart-controls [chartForm]="chartForm3"></app-chart-controls> -->
                                                 </div>

                                          </div>
                                          <div class="clmnbox">
                                                 <app-dashboard-todo-list-alt [data]="'CRM'"></app-dashboard-todo-list-alt>

                                          </div>
                                   </div>
                            </div>
                            <div class="clmnbox">
                                   <div class="title">
                                          <h4>
                                                 Scheduled meeting
                                          </h4>
                                          <button class="newiconlink red" title="Click to Schedule Meeting">
                                                 <svg>
                                                        <use href="./assets/img/sprite.svg#zoom"></use>
                                                 </svg>
                                          </button>
                                   </div>
                                   <div class="colmcontent">
                                          <div style="max-height: 27rem; overflow-y:auto">
                                                 <ul class="newmeetings">
                                                        <li>
                                                               <span>

                                                                      <strong>Schedule By: name</strong>

                                                                      <p>
                                                                             Topic - StartTime
                                                                      </p>
                                                               </span>
                                                               <a href="" target="_blank">
                                                                      <button class="btndark"
                                                                             title="Click to open link">
                                                                             Click here
                                                                      </button>

                                                               </a>

                                                        </li>
                                                 </ul>
                                          </div>
                                   </div>
                            </div>
                     </div>
              </div>
       </div>
       <div class="recrdashboard" id="template14" *ngIf="dashboardTemplateForm.value.templateCode == 'T14'">
              <div class="newjtsdbrcrt">
                     <div class="slidercolm">
                            <article>
                                   <h3>
                                          Recruitment Dashboard
                                   </h3>
                                   Recruitment dashboard help recuiters,hiring managers and HR teams understand every
                                   aspect of the hiring
                                   process.
                                   These include <br>
                                   tracking employer brand metrics show the overall interest job seekers have in working
                                   for the company,
                                   <br> to understanding how many candidates are moving through the hiring process.

                            </article>
                            <picture>
                                   <img src="./assets/img/main_right_bg.png" alt="">
                            </picture>
                     </div>
                     <div class="bottomdivisions">
                            <div class="leftcolmns">
                                   <div class="leftcolmns-top">
                                          <div class="columbox">
                                                 <div class="newcolumtitlles">
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Title</label>
                                                                      <input type="text"
                                                                             formControlName="chartBlock1_heading"
                                                                             class="form-control inputText"
                                                                             maxlength="30" placeholder="Enter Heading">
                                                               </div>
                                                        </div>
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Type</label>
                                                                      <ng-select class="form-control"
                                                                             formControlName="chartBlock1"
                                                                             [items]="chartTypeOptions"
                                                                             placeholder="Select Chart" bindLabel="name"
                                                                             bindValue="id"></ng-select>
                                                               </div>
                                                               <div class="col-2">
                                                                      <label class="control-label"
                                                                             style="color: transparent;">.</label>
                                                                      <div class="spriteBtns btn-margin-top"
                                                                             style="padding-top: 2px;">
                                                                             <button type="button"
                                                                                    class="back09 widgetsave"
                                                                                    title="Save"
                                                                                    (click)="updateChartType('chartBlock1','chartBlock1_heading')">
                                                                                    <svg class="icon">
                                                                                           <use
                                                                                                  href="assets/img/common-sprite.svg#saveIcon">
                                                                                           </use>
                                                                                    </svg>
                                                                             </button>
                                                                      </div>
                                                               </div>
                                                        </div>

                                                 </div>

                                                 <div id="columnchart_values" style="height: 23rem;">
                                                        <!-- <app-chart-controls [chartForm]="chartForm1"></app-chart-controls> -->
                                                 </div>

                                          </div>
                                          <div class="clmnbox ">
                                                 <app-recdashboard-pipeline-efficency-data>
                                                 </app-recdashboard-pipeline-efficency-data>
                                          </div>
                                   </div>
                                   <div class="leftcolmns-bottom">
                                          <div class="clmnbox">
                                                 <app-recdashboard-newhiring-bysource></app-recdashboard-newhiring-bysource>


                                          </div>
                                          <div class="columbox">
                                                 <div class="newcolumtitlles">
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Title</label>
                                                                      <input type="text"
                                                                             formControlName="chartBlock6_heading"
                                                                             class="form-control inputText"
                                                                             maxlength="30" placeholder="Enter Heading">
                                                               </div>
                                                        </div>
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Type</label>
                                                                      <ng-select class="form-control"
                                                                             formControlName="chartBlock6"
                                                                             [items]="chartTypeOptions"
                                                                             placeholder="Select Chart" bindLabel="name"
                                                                             bindValue="id"></ng-select>
                                                               </div>
                                                               <div class="col-2">
                                                                      <label class="control-label"
                                                                             style="color: transparent;">.</label>
                                                                      <div class="spriteBtns btn-margin-top"
                                                                             style="padding-top: 2px;">
                                                                             <button type="button"
                                                                                    class="back09 widgetsave"
                                                                                    title="Save"
                                                                                    (click)="updateChartType('chartBlock6','chartBlock6_heading')">
                                                                                    <svg class="icon">
                                                                                           <use
                                                                                                  href="assets/img/common-sprite.svg#saveIcon">
                                                                                           </use>
                                                                                    </svg>
                                                                             </button>
                                                                      </div>
                                                               </div>
                                                        </div>

                                                 </div>
                                                 <div id="curve_chart" style="height: 23rem;">
                                                        <!-- <app-chart-controls [chartForm]="chartForm6"></app-chart-controls> -->
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                            <div class="clmnbox">
                                   <div class="title">
                                          <h4>
                                                 Offer Decline
                                          </h4>

                                   </div>
                                   <div class="colmcontent">
                                          <div style="max-height: 27rem; overflow-y:auto">
                                                 <div class="orangebars">
                                                        <p> item <span> 11%</span></p>
                                                        <div class="thinprogress">
                                                               <div></div>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                            </div>
                     </div>
              </div>



       </div>
       <div class="oppertunitydb" id="template5" *ngIf="dashboardTemplateForm.value.templateCode == 'T15'">
              <div class="newjtsdbrcrt">
                     <div class="slidercolm">
                            <article>
                                   <h3>
                                          Opportunity Dashboard
                                   </h3>
                                   The Opportunity Dashboard page in Analytics gives you an overview of a particular
                                   opportunity.
                                   The top section displays key <br> information about the opportunity such as the
                                   Account Name,
                                   Owner,Type,Stage, and Close Date.

                            </article>
                            <picture>
                                   <img src="./assets/img/main_right_bg.png" alt="">
                            </picture>
                     </div>
                     <div class="bottomdivisions">
                            <div class="leftcolmns">
                                   <div class="leftcolmns-top">
                                          <div class="clmnbox">

                                                 <app-dashboard-opprunity-revenueclosed></app-dashboard-opprunity-revenueclosed>

                                          </div>
                                          <div class="columbox">

                                                 <div class="newcolumtitlles">
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Title</label>
                                                                      <input type="text"
                                                                             formControlName="chartBlock2_heading"
                                                                             class="form-control inputText"
                                                                             maxlength="30" placeholder="Enter Heading">
                                                               </div>
                                                        </div>
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Type</label>
                                                                      <ng-select class="form-control"
                                                                             formControlName="chartBlock2"
                                                                             [items]="chartTypeOptions"
                                                                             placeholder="Select Chart" bindLabel="name"
                                                                             bindValue="id"></ng-select>
                                                               </div>
                                                               <div class="col-2">
                                                                      <label class="control-label"
                                                                             style="color: transparent;">.</label>
                                                                      <div class="spriteBtns btn-margin-top"
                                                                             style="padding-top: 2px;">
                                                                             <button type="button"
                                                                                    class="back09 widgetsave"
                                                                                    title="Save"
                                                                                    (click)="updateChartType('chartBlock2','chartBlock2_heading')">
                                                                                    <svg class="icon">
                                                                                           <use
                                                                                                  href="assets/img/common-sprite.svg#saveIcon">
                                                                                           </use>
                                                                                    </svg>
                                                                             </button>
                                                                      </div>
                                                               </div>
                                                        </div>

                                                 </div>

                                                 <div id="barchart_material" style="height: 22rem;"></div>

                                          </div>
                                   </div>
                                   <div class="leftcolmns-bottom">

                                          <div class="columbox">

                                                 <div class="newcolumtitlles">
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Title</label>
                                                                      <input type="text"
                                                                             formControlName="chartBlock5_heading"
                                                                             class="form-control inputText"
                                                                             maxlength="30" placeholder="Enter Heading">
                                                               </div>
                                                        </div>
                                                        <div class="form-row">
                                                               <div class="col">
                                                                      <label class="control-label">Chart Type</label>
                                                                      <ng-select class="form-control"
                                                                             formControlName="chartBlock5"
                                                                             [items]="chartTypeOptions"
                                                                             placeholder="Select Chart" bindLabel="name"
                                                                             bindValue="id"></ng-select>
                                                               </div>
                                                               <div class="col-2">
                                                                      <label class="control-label"
                                                                             style="color: transparent;">.</label>
                                                                      <div class="spriteBtns btn-margin-top"
                                                                             style="padding-top: 2px;">
                                                                             <button type="button"
                                                                                    class="back09 widgetsave"
                                                                                    title="Save"
                                                                                    (click)="updateChartType('chartBlock5','chartBlock5_heading')">
                                                                                    <svg class="icon">
                                                                                           <use
                                                                                                  href="assets/img/common-sprite.svg#saveIcon">
                                                                                           </use>
                                                                                    </svg>
                                                                             </button>
                                                                      </div>
                                                               </div>
                                                        </div>

                                                 </div>
                                                 <div id="stackedbar_chart" style="height: 22rem;"></div>



                                          </div>
                                          <div class="clmnbox">
                                                 <app-dashboard-opprunity-campaigntype></app-dashboard-opprunity-campaigntype>
                                          </div>
                                   </div>
                            </div>
                            <div class="clmnbox">
                                   <div class="title">
                                          <h4>
                                                 Top 10 Open Opportunity
                                          </h4>

                                   </div>
                                   <div class="colmcontent" style="padding: 0;">
                                          <table class="chartable2" style="border-radius: 0;">


                                                 <thead style="background-color: #ddd; border-bottom: none;">
                                                        <tr>
                                                               <th>Opportunities Name</th>
                                                               <th>Status</th>
                                                        </tr>
                                                 </thead>
                                                 <tr>

                                                        <td>opp name</td>
                                                        <td class="greentxt">status</td>
                                                        <td class="redtxt">status</td>
                                                 </tr>
                                          </table>
                                   </div>
                            </div>
                     </div>
              </div>

       </div>
       <div class="dashBordContent" id="template2" *ngIf="dashboardTemplateForm.value.templateCode == 'T16'">
              <div class="contentsection">
                     <div class="crmgrid">
                            <div class="boxes columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock1_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock1"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock1','crm_chartBlock1_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="orangebars">
                                          <p>3 Leads in <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:80%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>3 Leads in <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:95%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Contract Made <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:80%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>3 Meeting Arranged <span>3</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:90%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Needs Demanded <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:75%"></div>
                                          </div>
                                   </div>

                                   <div class="orangebars">
                                          <p>2 Proposal made <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:75%"></div>
                                          </div>
                                   </div>

                                   <!-- <div class="orangebars">
                                          <p>2 Negotiations Started <span>2</span></p>
                                          <div class="thinprogress">
                                                 <div class="bars" style="width:60%"></div>
                                          </div>
                                   </div> -->
                            </div>

                            <div class="boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock2_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock2"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock2','crm_chartBlock2_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="columnchart_values" style="height: 20rem; width: 100%;padding-bottom: 1px">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock2">
                                                 </use>
                                          </svg>
                                   </div>
                                   <!-- <div id="columnchart_values" class="chartshapes show"
                                          style="height:60%; width: 90%; padding-top: 1rem; ">
                                         
                                   </div> -->
                            </div>

                            <div class=" boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock3_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock3"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock3','crm_chartBlock3_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <table class="dashboard_table">
                                          <thead>
                                                 <tr>
                                                        <th scope="col"> &nbsp; </th>
                                                        <th scope="col">Finance</th>
                                                        <th scope="col">Retail</th>
                                                        <th scope="col">Insurance</th>
                                                 </tr>
                                          </thead>
                                          <tbody>
                                                 <tr>
                                                        <th scope="row">Deals Won</th>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                        <td>62 <span class="up">47.6%</span></td>
                                                 </tr>
                                                 <tr>
                                                        <th scope="row">Deals Open</th>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                        <td>110 <span class="up">87.6%</span></td>
                                                 </tr>
                                                 <tr>
                                                        <th scope="row">Deals Lost</th>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                        <td>35 <span class="down">27.6%</span></td>
                                                 </tr>
                                          </tbody>
                                   </table>
                            </div>
                     </div>

                     <app-dashboard-crm-colored-column></app-dashboard-crm-colored-column>


                     <div class="crmgrid">
                            <div class="boxes columnChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock4_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock4"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock4','crm_chartBlock4_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div class="coloredbar">
                                          <div class="thik_progress red">
                                                 2000
                                          </div>
                                          <p>80%</p>
                                          <div class="thik_progress orange">
                                                 2000
                                          </div>

                                          <p>90%</p>
                                          <div class="thik_progress green">
                                                 3000
                                          </div>

                                          <p>50%</p>
                                          <div class="thik_progress blue">
                                                 2050
                                          </div>
                                   </div>
                                   <div class="colorbullet">
                                          <p><span class="red"></span>Leads Created</p>
                                          <p><span class="orange"></span>Leads Converted</p>
                                          <p><span class="green"></span>Leads Won</p>
                                          <p><span class="blue"></span>Leads Lost</p>
                                   </div>
                            </div>

                            <div class="boxes donutChart">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock5_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock5"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock5','crm_chartBlock5_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="TotalValueChart" style="width: 100%; height: 20rem;padding-bottom: 1px ">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock5">
                                                 </use>
                                          </svg>
                                   </div>
                                   <!-- <div id="TotalValueChart" class="chartshapes show"
                                          style="height:60%; width: 90%; padding-top: 1rem; ">
                                          
                                   </div> -->
                            </div>

                            <div class="boxes">
                                   <div class="coltitles">
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Title</label>
                                                        <input type="text" formControlName="crm_chartBlock6_heading"
                                                               class="form-control inputText" maxlength="30"
                                                               placeholder="Enter Heading">
                                                 </div>
                                          </div>
                                          <div class="form-row">
                                                 <div class="col">
                                                        <label class="control-label">Chart Type</label>
                                                        <ng-select class="form-control"
                                                               formControlName="crm_chartBlock6"
                                                               [items]="chartTypeOptions" placeholder="Select Chart"
                                                               bindLabel="name" bindValue="id"></ng-select>
                                                 </div>
                                                 <div class="col-2">
                                                        <label class="control-label"
                                                               style="color: transparent;">.</label>
                                                        <div class="spriteBtns btn-margin-top"
                                                               style="padding-top: 2px;">
                                                               <button type="button" class="back09 widgetsave"
                                                                      title="Save"
                                                                      (click)="updateChartType('crm_chartBlock6','crm_chartBlock6_heading')">
                                                                      <svg class="icon">
                                                                             <use
                                                                                    href="assets/img/common-sprite.svg#saveIcon">
                                                                             </use>
                                                                      </svg>
                                                               </button>
                                                        </div>
                                                 </div>
                                          </div>
                                   </div>
                                   <div id="budget_chart" style="width: 100%; height: 20rem;padding-bottom: 1px">
                                          <svg>
                                                 <use
                                                        [attr.xlink:href]="'../../../../assets/dashboard-sample/img/sprite.svg#'+dashboardTemplateForm.value.crm_chartBlock6">
                                                 </use>
                                          </svg>
                                   </div>
                            </div>
                     </div>

              </div>
              <div class="boardside dealslist">
                     <!-- <div class="coltitles"> -->
                     <!-- <h3>Top 5 Deals</h3> -->
                     <div class="form-row">
                            <div class="col">
                                   <!-- <label class="control-label">Chart Type</label> -->
                                   <input type="text" formControlName="crm_staticBlock1_heading"
                                          class="form-control inputText" maxlength="30" placeholder="Enter Heading">
                            </div>
                            <div class="col-2">
                                   <!-- <label class="control-label"
                                          style="color: transparent;">.</label> -->
                                   <div class="spriteBtns btn-margin-top" style="padding-top: 2px;">
                                          <button type="button" class="back09 widgetsave" title="Save"
                                                 (click)="updateChartType('crm_staticBlock1','crm_staticBlock1_heading')">
                                                 <svg class="icon">
                                                        <use href="assets/img/common-sprite.svg#saveIcon">
                                                        </use>
                                                 </svg>
                                          </button>
                                   </div>
                            </div>
                     </div>

                     <app-crm-top-five-deals></app-crm-top-five-deals>
              </div>
       </div>
</form>